"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var change_case_1 = require("change-case");
var capital_dash_case_1 = __importDefault(require("./util/capital-dash-case"));
var ARRAY_TEXT_FIELDS = ['n', 'adr'];
/** A vCard property. */
var Property = /** @class */ (function () {
    /**
     * A class describing a single vCard property.
     * Will almost always be a member of a
     * {@link VCard}'s [props]{@link VCard.props} map.
     *
     * Accepts either 2-4 arguments, or 1 argument in jCard property format.
     * @param arg the field, or a jCard property
     * @param value
     * @param params
     * @param group
     */
    function Property(arg, value, params, group) {
        this.field = '';
        /**
         * the value of the property.
         * @example '(123) 456 7890'
         */
        this.value = '';
        /**
         * An jCard parameters object.
         * @example
         * {
         * 	type: ['work', 'voice', 'pref'],
         * 	value: 'uri'
         * }
         */
        this.params = {};
        // Construct from arguments
        if (value !== undefined && typeof arg === 'string') {
            this.field = arg;
            this.value = value;
            this.params = params || {};
            this.group = group;
        }
        // Construct from vcf property line
        else if (value === undefined &&
            params === undefined &&
            typeof arg === 'string') {
            this.parseFromLine(arg);
        }
        // construct from jcard
        else if (value === undefined &&
            params === undefined &&
            typeof arg === 'object') {
            this.parseFromJCardProperty(arg);
        }
        // invalid property
        else {
            throw new Error('invalid Property constructor');
        }
    }
    Property.prototype.parseFromLine = function (line) {
        var e_1, _a;
        var _this = this;
        var pattern = /^([^;:]+)((?:;(?:[^;:]+))*)(?:\:([\s\S]+))?$/i;
        var match = pattern.exec(line);
        if (!match)
            throw new Error('Invalid format for vcf line:\n' + line);
        var name = match[1].split('.');
        var property = change_case_1.camelCase(name.pop());
        var group = name.pop();
        var value = match[3];
        // ["TYPE=work,voice", "VALUE=uri"]
        var paramArray = match[2]
            ? match[2].replace(/^;|;$/g, '').split(';') // remove leading semicolon
            : [];
        var _loop_1 = function (p) {
            var parts = p.split('=');
            var k = change_case_1.camelCase(parts[0]);
            var v = parts[1];
            if (v == null || v === '') {
                v = parts[0];
                k = 'type';
            }
            if (k === 'type') {
                // TODO what does this line do?
                // https://github.com/jhermsmeier/node-vcf/blob/a1a01dd815d1126b2c200aa4d1748feb323c48b8/lib/parse-lines.js#L27
                if (v[0] === '"' && v[v.length - 1] === '"' && v.indexOf(',') !== -1)
                    v = v.slice(1, -1);
                v.toLowerCase()
                    .split(',')
                    .forEach(function (val) { return _this.addParam(k, val); });
                return "continue";
            }
            this_1.addParam(k, v);
        };
        var this_1 = this;
        try {
            for (var paramArray_1 = __values(paramArray), paramArray_1_1 = paramArray_1.next(); !paramArray_1_1.done; paramArray_1_1 = paramArray_1.next()) {
                var p = paramArray_1_1.value;
                _loop_1(p);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (paramArray_1_1 && !paramArray_1_1.done && (_a = paramArray_1.return)) _a.call(paramArray_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        this.field = property;
        this.value = value;
        this.group = group;
    };
    Property.prototype.parseFromJCardProperty = function (_jCardProp) {
        var jCardProp = JSON.parse(JSON.stringify(_jCardProp));
        this.field = change_case_1.camelCase(jCardProp[0]);
        this.params = jCardProp[1];
        this.params['value'] = jCardProp[2];
        this.value = Array.isArray(jCardProp[3])
            ? jCardProp[3].join(';')
            : jCardProp[3];
    };
    Property.prototype.addParam = function (key, value) {
        if (Array.isArray(this.params[key])) {
            ;
            this.params[key].push(value);
        }
        else if (this.params[key] != null) {
            this.params[key] = [this.params[key], value];
        }
        else {
            this.params[key] = value;
        }
    };
    /** Returns a copy of the Property's string value. */
    Property.prototype.getValue = function () {
        return this.value + '';
    };
    /** Returns `true` if all the following are true:
     * - the property's value contains charactes other than `;`
     * - the property has no parameters
     */
    Property.prototype.isEmpty = function () {
        return ((this.value == null || !/[^;]+/.test(this.value)) &&
            Object.keys(this.params).length === 0);
    };
    /** Returns a readonly string copy of the property's field. */
    Property.prototype.getField = function () {
        return this.field + '';
    };
    /**
     * Returns a `.vcf` formatted line.
     * @param version (unfinished)
     */
    Property.prototype.toString = function (version) {
        var _this = this;
        var paramReducer = function (accumulator, key) {
            var param = _this.params[key];
            return (accumulator +
                ';' +
                key.toUpperCase() +
                '=' +
                (Array.isArray(param) ? param.join(',') : param));
        };
        return ((this.group ? this.group.toLowerCase() + '.' : '') +
            capital_dash_case_1.default(this.field) +
            // (Object.keys(this.params).length > 0 ? ';' : '') +
            Object.keys(this.params).reduce(paramReducer, '') +
            ':' +
            this.value);
    };
    /**
     * Returns a JSON array in a [jCard property]{@link JCardProperty} format
     */
    Property.prototype.toJSON = function () {
        var newParams = __assign({}, this.params);
        delete newParams['value'];
        return [
            this.field,
            newParams,
            this.params['value'] || 'text',
            ARRAY_TEXT_FIELDS.includes(this.field)
                ? this.value.split(';')
                : this.value
        ];
    };
    return Property;
}());
exports.Property = Property;
